import axios from 'axios';
import loadable  from '@loadable/component'

import '../scss/style.scss';
import registerComponents from './registerComponent';
import MobileMenu from "./header/MobileMenu";
import AddToCartButton from "./product/AddToCartButton";
import AddToCartIcon from "./category/AddToCartIcon";
import AddToWishlistButton from "./product/AddToWishlistButton";
import CartIcon from "./header/CartIcon";
import WishlistIcon from "./header/WishlistIcon";
const RelatedCategories = loadable(() => import(/* webpackChunkName: "relatedcategories" */'./product/RelatedCategories'));
const RelatedColors = loadable(() => import(/* webpackChunkName: "relatedcolors" */'./product/RelatedColors'));
const RelatedProducts = loadable(() => import(/* webpackChunkName: "relatedproducts" */'./product/RelatedProducts'));
import AddToWishlistIcon from "./category/AddToWishlistIcon";
const ProductGallery = loadable(() => import(/* webpackChunkName: "productgallery" */'./product/ProductGallery'));
import ConnectedFilters from "./filter/ConnectedFilters";
const FilterTags = loadable(() => import(/* webpackChunkName: "filter-filtertags" */'./filter/FilterTags'))
const FiltersPagerAjax = loadable(() => import(/* webpackChunkName: "filter-pagerajax" */'./filter/FiltersPagerAjax'))
const FiltersPagerLink = loadable(() => import(/* webpackChunkName: "filter-pagerlink" */'./filter/FiltersPagerLink'))
const FilterOrderByAjax = loadable(() => import(/* webpackChunkName: "filter-orderbyajax" */'./filter/FilterOrderByAjax'))
const FilterOrderByLink = loadable(() => import(/* webpackChunkName: "filter-orderbylink" */'./filter/FilterOrderByLink'))
const FilterProductWrapper = loadable(() => import(/* webpackChunkName: "filter-productwrapper" */'./filter/FilterProductWrapper'))
const FilterProductCount = loadable(() => import(/* webpackChunkName: "filter-productcount" */'./filter/FilterProductCount'))

import SearchBox from "./search/SearchBox";
import UserMenu from "./header/UserMenu";
import NewsletterForm from "./newsletter/NewsletterForm";
const CustomerAddress = loadable(() => import(/* webpackChunkName: "customeraddress" */'./components/CustomerAddress'));
import Notification from "./components/Notification";
import FormattedSelect from "./components/FormattedSelect";
const Wishlist = loadable(() => import(/* webpackChunkName: "wishlist" */'./views/wishlist/Wishlist'));
const WishlistDeprecated = loadable(() => import(/* webpackChunkName: "wishlistdeprecated" */'./wishlist/Wishlist'));
const ProductDescription = loadable(() => import(/* webpackChunkName: "productdescription" */'./components/ProductDescription'));
const ProductSizeSelector = loadable(() => import(/* webpackChunkName: "productsizeselector" */'./components/ProductSizeSelector'));
const StockAvailability = loadable(() => import(/* webpackChunkName: "stockavailability" */'./product/StockAvailability'));
const Brands = loadable(() => import(/* webpackChunkName: "brands" */'./brands/Brands'));
import Kit from "./kit/Kit";
const RegistrationButton = loadable(() => import(/* webpackChunkName: "registrationbutton" */'./registration/RegistrationButton'));
const RememberMe = loadable(() => import(/* webpackChunkName: "rememberme" */'./login/RememberMe'))
import MegaMenu from "./header/MegaMenu";
import Intro from "./intro/Intro";
import ContactUsButton from "./contact-us/ContactUsButton";
import NotificationHelper from "./components/NotificationHelper";
const OrderSummary = loadable(() => import(/* webpackChunkName: "ordersummary" */'./order-summary'));;
const CheckoutPaymentMethod = loadable(() => import(/* webpackChunkName: "checkoutpaymentmethod" */'./checkout/CheckoutPaymentMethod'));
const CheckoutBillingAddress = loadable(() => import(/* webpackChunkName: "checkoutbillingaddress" */'./checkout/CheckoutBillingAddress'));
const CheckoutShippingAddress = loadable(() => import(/* webpackChunkName: "checkoutshippingaddress" */'./checkout/CheckoutShippingAddress'));
import BannerZone from "./banners/BannerZone";
const CheckoutConfirm = loadable(() => import(/* webpackChunkName: "checkoutconfirm" */'./checkout/CheckoutConfirm'))
const CategoryPage = loadable(() => import(/* webpackChunkName: "categorypage" */'./category/CategoryPage'))
const CustomerRegistration = loadable(() => import(/* webpackChunkName: "customerregistration" */'./customer/Registration'))
import smoothscroll from 'smoothscroll-polyfill';
import scrollRestorer from './services/scrollRestorer';
const ProductInfo = loadable(() => import(/* webpackChunkName: "productinfo" */'./product/ProductInfo'));
const ProductInfoBlocks = loadable(() => import(/* webpackChunkName: "productinfoblocks" */'./product/ProductInfoBlocks'));
const ProductDetails = loadable(() => import(/* webpackChunkName: "productdetails" */'./product/ProductDetails'));
// const SearchPageDeprecated = loadable(() => import(/* webpackChunkName: "searchpage-deprecated" */'./category/SearchPage'));  
const SearchPage = loadable(() => import(/* webpackChunkName: "searchpage" */'./views/search/SearchPage'));
const ShoppingCart = loadable(() => import(/* webpackChunkName: "shoppingcart" */'./views/shopping-cart/Cart'));
const PageNotFound = loadable(() => import(/* webpackChunkName: "pagenotfound" */'./views/PageNotFound'));
const BlogRoute = loadable(() => import(/* webpackChunkName: "BlogRoute" */'./views/blog/BlogRoute'));
const TopicDetails = loadable(() => import(/* webpackChunkName: "TopicDetails" */'./views/topic/TopicDetails'));
const CheckoutScreen = loadable(() => import(/* webpackChunkName: "CheckoutV2" */'./views/checkout/CheckoutScreen'));
const ShopFinderScreen = loadable(() => import(/* webpackChunkName: "ShopFinder" */'./views/shop-finder/ShopsScreen'));
const PurchaseCompletedScreen = loadable(() => import(/* webpackChunkName: "PurchaseCompletedScreen" */'./views/checkout/PurchaseCompletedScreen'));
const CustomerNav = loadable(() => import(/* webpackChunkName: "CustomerNav" */'./components/Customer/CustomerNav'));
const CustomerRewardPoints = loadable(() => import(/* webpackChunkName: "CustomerRewardPoints" */'./components/Customer/RewardPoints'));
const CustomerRewardPointsNew = loadable(() => import(/* webpackChunkName: "CustomerRewardPoints" */'./components/CustomerNew/RewardPoints'));
const CustomerBackButton = loadable(() => import(/* webpackChunkName: "CustomerBackButton" */'./components/CustomerNew/CustomerBackButton'));
const CustomerOrdersNew = loadable(() => import(/* webpackChunkName: "CustomerOrders" */'./components/CustomerNew/CustomerOrders'));
const CustomerChangeEmailNew = loadable(() => import(/* webpackChunkName: "CustomerChangeEmail" */'./components/CustomerNew/CustomerChangeEmail'));
const CustomerDashboard = loadable(() => import(/* webpackChunkName: "CustomerDashboard" */'./components/CustomerNew/CustomerDashboard'));
const CustomerOrderDetailsNew = loadable(() => import(/* webpackChunkName: "CustomerOrderDetails" */'./components/CustomerNew/CustomerOrderDetails'));
const CustomerInfoNew = loadable(() => import(/* webpackChunkName: "CustomerInfo" */'./components/CustomerNew/CustomerInfo'));
const CustomerChangePasswordNew = loadable(() => import(/* webpackChunkName: "CustomerChangePassword" */'./components/CustomerNew/CustomerChangePassword'));
const NewbornEquipments = loadable(() => import(/* webpackChunkName: "NewbornEquipment" */'./views/common/NewbornEquipmentsScreen'));
const UpsellScreen = loadable(() => import(/* webpackChunkName: "UpsellScreen" */'./views/common/UpsellScreen'));

import Footer from './footer/Footer';
import SafePayBox from './components/Footer/SafePayBox';
import Icon from './components/Icon';
import SearchAutoCompleteBox from './layout/SearchAutoCompleteBox/SearchAutoCompleteBox';
/* import './registerFAS'; */
import './services/middleware/axios';

// kick off the polyfill!
smoothscroll.polyfill();

scrollRestorer();

const csrfToken = document.querySelector('input[name="__RequestVerificationToken"]').value;
axios.defaults.headers.common['RequestVerificationToken'] = csrfToken;

if (process.env.NODE_ENV === 'development') {
    // axios.defaults.baseURL = 'https://dev.brendon.hu';
    const { worker } = require('../mocks/browser')
    worker.start({
        onUnhandledRequest: 'bypass',
        serviceWorker: {
            options: {
                // Narrow the scope of the Service Worker to intercept requests
                // only from pages under this path.
                scope: '/'
            },
            url: '/mockServiceWorker.js',
        },
    })
}


const components = {
    Brands,
    MobileMenu,
    AddToCartButton,
    AddToCartIcon,
    AddToWishlistButton,
    CartIcon,
    WishlistIcon,
    RelatedCategories,
    RelatedColors,
    RelatedProducts,
    AddToWishlistIcon,
    ProductGallery,
    ConnectedFilters,
    FilterTags,
    FiltersPagerAjax,
    FiltersPagerLink,
    FilterOrderByAjax,
    FilterOrderByLink,
    FilterProductWrapper,
    FilterProductCount,
    SearchBox,
    UserMenu,
    NewsletterForm,
    CustomerAddress,
    Notification,
    FormattedSelect,
    Wishlist,
    ProductDescription,
    ProductSizeSelector,
    StockAvailability,
    Kit,
    RegistrationButton,
    RememberMe,
    MegaMenu,
    Intro,
    ContactUsButton,
    NotificationHelper,
    OrderSummary,
    CheckoutPaymentMethod,
    CheckoutBillingAddress,
    CheckoutShippingAddress,
    BannerZone,
    CheckoutConfirm,
    CategoryPage,
    ProductInfo,
    ProductInfoBlocks,
    CustomerRegistration,
    ProductDetails,
/*     SearchPageDeprecated, */
    Icon,
    ShoppingCart,
    PageNotFound,
    SafePayBox,
    BlogRoute,
    TopicDetails,
    Footer,
    CheckoutScreen,
    ShopFinderScreen,
    WishlistDeprecated,
    SearchAutoCompleteBox,
    SearchPage,
    PurchaseCompletedScreen,
    CustomerNav,
    CustomerRewardPoints,
    CustomerRewardPointsNew,
    CustomerBackButton,
    CustomerOrdersNew,
    CustomerDashboard,
    CustomerChangeEmailNew,
    CustomerOrderDetailsNew,
    CustomerInfoNew,
    CustomerChangePasswordNew,
    NewbornEquipments,
    UpsellScreen,
};

registerComponents(components);

window.addEventListener('load', (loadEvent) => {
    const recoveryForm = document.getElementById('password-recovery-form');
    let disabled = false;
    recoveryForm?.addEventListener('submit', (formEvent) => {
        if(disabled) {
            return false;
        }
        disabled = true;
        return true;
    });
    if (recoveryForm) {
        const emailField = document.querySelector("#Email")
        emailField?.addEventListener('change', () => { disabled = false })
    }
})
